var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"message-location",attrs:{"href":_vm.data.href,"target":"_blank","title":"点击查看详情"}},[_c('span',{staticClass:"el-icon-location-outline"},[_vm._v(_vm._s(_vm.data.description))]),_c('img',{attrs:{"src":_vm.data.url}})])}
var staticRenderFns = []

export { render, staticRenderFns }